module.exports = __webpack_public_path__ + "img/3-Intersection 1.dd68e91a.png";